<script>
import { AppLayout, PageHeader } from '@/components/layout'
import appConfig from '@/app.config'
import General from './general'
import Password from './password'
import Preferences from './preferences'
import Addresses from './addresses'
import { authComputed } from '@/state/helpers'
export default {
  name: 'profile',
  components: {
    AppLayout,
    PageHeader,
    General,
    Password,
    Preferences,
    Addresses
  },
  data: () => ({
    visible: {
      general: true,
      password: false,
      preferences: false,
      addresses: false
    }
  }),
  computed: {
    ...authComputed
  },
  methods: {
    onShow (tab) {
      if (this.visible.hasOwnProperty(tab)) this.visible[tab] = true
      Object.keys(this.visible).forEach(key => {
        if (key !== tab) this.visible[key] = false
      })
    }
  }
}
</script>
<template>
  <AppLayout>
    <PageHeader title="Profile" />
    <b-row>
      <b-col cols="12">
        <b-card no-body class="email-leftbar p-2">
          <b-nav vertical class="side-nav">
            <b-nav-item
              v-on:click="onShow('general')"
              :class="{ 'router-link-active': visible.general }"
            >
              <i class="bx bx-user mr-2"></i>Profile
            </b-nav-item>
            <b-nav-item
              v-on:click="onShow('password')"
              :class="{ 'router-link-active': visible.password }"
            >
              <i class="bx bx-key mr-2"></i>Password
            </b-nav-item>
            <b-nav-item
              v-on:click="onShow('addresses')"
              :class="{ 'router-link-active': visible.addresses }"
              v-if="userRole === 'user'"
            >
              <i class="bx bx-map mr-2"></i>Addresses
            </b-nav-item>
            <!-- <b-nav-item
              v-on:click="onShow('preferences')"
              :class="{ 'router-link-active': visible.preferences }"
            >
              <i class="bx bx-slider mr-2"></i>Preferences
            </b-nav-item> -->
          </b-nav>
        </b-card>

        <div class="email-rightbar">
          <general v-if="visible.general" />

          <password v-if="visible.password" />

          <preferences v-if="visible.preferences" />

          <addresses v-if="visible.addresses && userRole === 'user'" />
        </div>
      </b-col>
    </b-row>
  </AppLayout>
</template>
